import { getAppEnvironment, AppEnvironment } from '@/lib/utils';

/**
 * Returns the EdgeLink environment code for the install script URL
 * p = production, s = staging, d = development/local
 */
export function getEdgeLinkEnvCode(): 'p' | 's' | 'd' {
  const env = getAppEnvironment();
  switch (env) {
    case AppEnvironment.Production:
      return 'p';
    case AppEnvironment.Staging:
      return 's';
    case AppEnvironment.Local:
      return 'd';
  }
}

/**
 * Generates the EdgeLink install command for the given auth token
 */
export function generateEdgeLinkInstallCommand(authToken: string): string {
  const envCode = getEdgeLinkEnvCode();
  return `curl -sSL https://install.watchful.co.nz/edgelink/${envCode}/${authToken}/install.sh | sh`;
}

/**
 * Returns the EdgeLink uninstall script URL
 */
export function getEdgeLinkUninstallUrl(): string {
  return 'https://install.watchful.co.nz/edgelink/uninstall.sh';
}

/**
 * Generates the EdgeLink uninstall command
 */
export function generateEdgeLinkUninstallCommand(): string {
  return `curl -sSL ${getEdgeLinkUninstallUrl()} | sh`;
}
